import React, { useEffect, useRef, useState } from "react"
import { Container, Row, Col, Collapse } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { getRegularClasses, formatTime, formatFromTime, formaToTime } from '../../Utils/utils';
import moment from "moment/moment";
import { makeStyles } from '@material-ui/core/styles';
import Select from 'react-select';
import './style.css'
import SetupModal from "./SetupModal";
import DataTableExtensions from "react-data-table-component-extensions";
import config from "../../config/config";
import axios from "axios";
import SuccessModal from "../Modals/SuccessModal";
import WarningModal from "../Modals/WarningModal";
import { toast } from "react-toastify";
import NotesshowModal from "../Modals/NotesshowModal";
import downImg from "./down-arrow.svg";
import UpImg from "./up-arrow.svg";
import CustomSearch from "../CustomSearch";
import { normalTime, TimetoConvert } from "../../Utils/TimeUtils";
import CanBeAddedModal from "./CanBeAddedModal";
import LoadingSpinner from "../LoadingSpinner";
import { getInstructorDetailsWithSchedule } from "../../Utils/utils";


const ExpandedComponent = (props) => {
  const { data, setShowModal, setLangId, setSelectedRow, setCloseRow, setShowTime, setApprovedArr, approvedArr, setShowCanAddedModal, setShowCanAddedPotential, setCanAddedData, setFullData, setStudentId, setApprovedRegArr } = props;
  const [newArray, setNewArray] = useState([])
  const [notesShow, setNotesShow] = useState(false);
  const [selectedNote, setSelectedNote] = useState(null);

  const columns = [
    {
      name: 'Course No.',
      selector: row => `${row.courseNumber}`,
      sortable: false,
      width: '125px'
    },
    {
      name: "Rank",
      cell: (row) =>
        <>
          <div className="row">
            <div className='cell-upper'>{row.rank}</div>
          </div>
        </>,
      width: "70px",
    },
    {
      name: 'Name',
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.firstName}
          <br />
          {row.lastName}
        </div>
      ),
      sortable: false,
      width: '110px',
    },
    {
      name: "Language",
      cell: (row) =>
        <>
          <div className="row">
            <div className='cell-upper'>{row.language}</div>
          </div>
        </>,
      width: "90px",
    },
    // {
    //   name: 'Last Name',
    //   cell: (row) => (
    //     <div style={{ 
    //       whiteSpace: 'normal', 
    //       wordBreak: 'break-word', 
    //       overflow: 'hidden', 
    //       textOverflow: 'ellipsis', 
    //       fontSize:'12px'
    //     }}>
    //       {row.lastName}
    //     </div>
    //   ),
    //   sortable: false,
    //   width: '110px',
    // },
    {
      name: (
        <div>
          Home Email
          <br />
          Phone Number
        </div>
      ),
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}>
          {row.homeEmail}
          <br /><br />
          {row.phoneNumber}
        </div>
      ),
      sortable: false,
      width: '230px'
    },
    // {
    //   name: 'Phone number',
    //   selector: row => `${row.phoneNumber}`,
    //   sortable: false,
    //   width:'120px'
    // },
    {
      name: 'Timezone',
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}>
          {row.timeZone}
        </div>
      ),
      width: '160px',
      sortable: false,
    },
    {
      name: (
        <div>
          Start Date
          <br />
          End Date
        </div>
      ),

      selector: (row) => (
        <div >
          {moment(row.availableStartDateMs).format('MM/DD/YYYY')}
          <br /><br />
          {moment(row.availableEndDateMs).format('MM/DD/YYYY')}
        </div>
      ),

      sortable: false,
      width: '110px'
    },

    // {
    //   name: 'Availability in EST',
    //   width: '360px',
    //   cell: (row) => <div>
    //     <table>
    //       <thead className="cell-head">
    //         <th>Mon</th>
    //         <th>Tue</th>
    //         <th>Wed</th>
    //         <th>Thur</th>
    //         <th>Fri</th>
    //         <th>Sat</th>
    //         <th>Sun</th>
    //       </thead>
    //       <tbody>
    //         <tr className="cell-row">
    //           <td>
    //             <div className="display-time">
    //               {row.updatedSchedule?.MON?.from ? <>
    //                 {/* <div>{formatFromTime(row.updatedSchedule?.MON?.from)}</div>
    //                 <div>-</div>
    //                 <div>{formaToTime(row.updatedSchedule?.MON?.to)}</div> */}

    //               </> : ''}
    //             </div>
    //           </td>
    //           <td>
    //             <div className="display-time">
    //               {row.updatedSchedule?.TUE?.from == null ? '' : 
    //                 <>
    //                   <div>{formatFromTime(row.updatedSchedule?.TUE?.from)}</div>
    //                   <div>-</div>
    //                   <div>{formaToTime(row.updatedSchedule?.TUE?.to)}</div>
    //                 </>
    //               }
    //             </div>
    //           </td>
    //           <td>
    //             <div className="display-time">
    //               {row.updatedSchedule?.WED?.from ? <>
    //                 <div>{formatFromTime(row.updatedSchedule?.WED?.from)}</div>
    //                 <div>-</div>
    //                 <div>{formaToTime(row.updatedSchedule?.WED?.to)}</div>
    //               </> : ''}
    //             </div>
    //           </td>
    //           <td>
    //             <div className="display-time">
    //               {row.updatedSchedule?.THUR?.from ? <>
    //                 <div>{formatFromTime(row.updatedSchedule?.THUR?.from)}</div>
    //                 <div>-</div>
    //                 <div>{formaToTime(row.updatedSchedule?.THUR?.to)}</div>
    //               </> : ''}
    //             </div>
    //           </td>
    //           <td>
    //             <div className="display-time">
    //               {row.updatedSchedule?.FRI?.from ? <>
    //                 <div>{formatFromTime(row.updatedSchedule?.FRI?.from)}</div>
    //                 <div>-</div>
    //                 <div>{formaToTime(row.updatedSchedule?.FRI?.to)}</div>
    //               </> : ''}
    //             </div>
    //           </td>
    //           <td>
    //             <div className="display-time">
    //               {row.updatedSchedule?.SAT?.from ? <>
    //                 <div>{formatFromTime(row.updatedSchedule?.SAT?.from)}</div>
    //                 <div>-</div>
    //                 <div>{formaToTime(row.updatedSchedule?.SAT?.to)}</div>
    //               </> : ''}
    //             </div>
    //           </td>
    //           <td>
    //             <div className="display-time">
    //               {row.updatedSchedule?.SUN?.from ? <>
    //                 <div>{formatFromTime(row.updatedSchedule?.SUN?.from)}</div>
    //                 <div>-</div>
    //                 <div>{formaToTime(row.updatedSchedule?.SUN?.to)}</div>
    //               </> : ''}
    //             </div>
    //           </td>
    //         </tr>
    //       </tbody>
    //     </table>
    //   </div>,
    //   sortable: false,
    // },

    {
      name: 'Availability in EST',
      width: '375px',
      cell: (row) => <div>
        <table>
          <thead className="cell-head">
            <th>Mon</th>
            <th>Tue</th>
            <th>Wed</th>
            <th>Thur</th>
            <th>Fri</th>
            <th>Sat</th>
            <th>Sun</th>
          </thead>
          <tbody>
            <tr className="cell-row">
              <td>
                <div className="display-time">
                  {row.schedule?.MON?.from ? <> {TimetoConvert(row.schedule?.MON?.from, row.schedule?.MON?.to, row.schedule?.MON?.timezone)} </> : ''}
                </div>
              </td>
              <td>
                <div className="display-time">
                  {row.schedule?.TUE?.from ? <> {TimetoConvert(row.schedule?.TUE?.from, row.schedule?.TUE?.to, row.schedule?.TUE?.timezone)} </> : ''}
                </div>
              </td>
              <td>
                <div className="display-time">
                  {row.schedule?.WED?.from ? <> {TimetoConvert(row.schedule?.WED?.from, row.schedule?.WED?.to, row.schedule?.WED?.timezone)} </> : ''}
                </div>
              </td>
              <td>
                <div className="display-time">
                  {row.schedule?.THUR?.from ? <> {TimetoConvert(row.schedule?.THUR?.from, row.schedule?.THUR?.to, row.schedule?.THUR?.timezone)} </> : ''}
                </div>
              </td>
              <td>
                <div className="display-time">
                  {row.schedule?.FRI?.from ? <> {TimetoConvert(row.schedule?.FRI?.from, row.schedule?.FRI?.to, row.schedule?.FRI?.timezone)} </> : ''}
                </div>
              </td>
              <td>
                <div className="display-time">
                  {row.schedule?.SAT?.from ? <> {TimetoConvert(row.schedule?.SAT?.from, row.schedule?.SAT?.to, row.schedule?.SAT?.timezone)} </> : ''}
                </div>
              </td>
              <td>
                <div className="display-time">
                  {row.schedule?.SUN?.from ? <> {TimetoConvert(row.schedule?.SUN?.from, row.schedule?.SUN?.to, row.schedule?.SUN?.timezone)} </> : ''}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>,
      sortable: false,
    },

    {
      name: 'Can be added to',
      width: '150px',
      selector: (row) => (
        <div className='cell-link'
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: '12px'
          }}
          onClick={() => {
            setStudentId(row.id)
            setFullData(data)
            setCanAddedData(row?.canBeAddedTo)
            setShowCanAddedModal(true)
          }}
        >
          <div>
            {row.canBeAddedTo?.mainClassNumber}
          </div>
        </div>
      ),
      // selector: row => ``,
      sortable: false,
    },

    {
      name: "Notes",
      width: '200px',
      selector: (row) =>
        <div style={{
          margin: '5px',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.notes}
        </div>
    },

    // {
    //   name: "Notes",
    //   cell: (row) => {
    //     const handleOpenModal = (notes) => {
    //       setSelectedNote(notes); 
    //       setNotesShow(true); 
    //     };
    //     return (
    //       <div className='cell-link'>
    //         {/* <i 
    //           className="fas fa-eye"
    //           title="Notes"
    //           onClick={() => handleOpenModal(row.notes)} 
    //         ></i> */}
    //          {row.notes}
    //       </div>
    //     );
    //   }
    // }
  ];

  useEffect(() => {
    const copiedData = [...data.students];
    setNewArray(copiedData);
  }, [data.students]);

  const conditionalRowStyles = [
    {
      when: row => row.space_a_ind === 'T',
      style: {
        backgroundColor: '#fb6f46',
        color: 'black',
        '&:hover': {
          backgroundColor: '#FDB7A2 !important',
          cursor: 'pointer',
        },
      },
    }
  ];
  return (
    <>
      <div style={{ transition: 'height 3s' }}>
        <DataTable
          columns={columns}
          conditionalRowStyles={conditionalRowStyles}
          data={newArray}
        />
        <Row className="w-100  mb-3 mt-2">
          <Col md={4}>
            <button
              className="btn btn-primary btn-xs mx-3"
              disabled={newArray.every((data) => data.space_a_ind == "T")}
              onClick={(e) => {
                if (newArray.length == 1 && newArray[0].space_a_ind == "T") {
                  setSelectedRow(data)
                  setShowTime(true)
                  setLangId(newArray[0]?.lang.id)
                  setShowModal(true)
                } else {
                  setShowTime(false)
                  setSelectedRow(data)
                  setLangId(newArray[0]?.lang.id)
                  setShowModal(true)
                }
              }}
            >
              Setup Schedule
            </button>
          </Col>
          {(data.isReadyToApprove == true && data.isApproved == false) &&
            <Col md={4}>
              <button
                className="btn btn-success btn-xs "
                onClick={(e) => {

                  const hasSelectedTiming = data.newMatchedTimings.some(item => item.isSelected);
                  if (data.instructorAccepted && !hasSelectedTiming) {
                    //  console.log(data.instructorAccepted ,"new matchedtiming select data.....")
                    alert('Please select time to proceed')
                  } else {
                    // if (!data.instructorAccepted) {
                    //   if (data?.newMatchedTimings !== undefined) {
                    //     data?.newMatchedTimings.map((time, index) => {
                    //       time.isSelected = true;
                    //     })
                    //   }

                    // }
                    setSelectedRow(data.newMatchedTimings)
                    setSelectedRow(data.isApproved = true)
                    setCloseRow(data)
                    var arr = [...approvedArr]
                    arr.push(data)
                    setApprovedArr(arr)
                  }


                }}
              >
                Approve
              </button>
            </Col>
          }
        </Row>
      </div >
      {notesShow && (
        <NotesshowModal
          notesShow={notesShow}
          setNotesShow={setNotesShow}
          selectedNote={selectedNote}
          setSelectedNote={setSelectedNote}
          notes={selectedNote}
        />
      )}
    </>
  )
};

const GroupedClasses = (props) => {
  const [regualarClasses, setRegualarClasses] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [lang_id, setLangId] = useState('');
  const [isSetup, setIsSetup] = useState(false);
  const [closeRow, setCloseRow] = useState('');
  const [approvedArr, setApprovedArr] = useState([]);
  const [showTime, setShowTime] = useState(false);
  const [isSuccessShow, setIsSuccessShow] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const [filterText, setFilterText] = useState('');
  const handleFilterChange = (e) => { setFilterText(e.target.value); };
  const toggleCollapse = () => { setIsOpen(!isOpen); };
  const [showCanAddedModal, setShowCanAddedModal] = useState(false);
  const [showCanAddedPotential, setShowCanAddedPotential] = useState(false);
  const [canAddedData, setCanAddedData] = useState('');
  const [fullData, setFullData] = useState('');
  const [studentId, setStudentId] = useState('');
  const [langVal, setLangVal] = useState(null);
  const [isClearable, setIsClearable] = useState(true);

  const getAllRegularClasses = async () => {
    setIsLoading(true)
    setRegualarClasses(props.selectArray)
    setIsLoading(false)
  }

  useEffect(() => {
    getAllRegularClasses()
  }, [])

  const langOptions = [
    ...new Map(
      props.selectArray.map(item => [item.language.code, {
        value: item.language.code,
        label: item.language.language
      }])
    ).values()
  ];





  const columns = [
    {
      name: 'Course Number',
      selector: row => `+ ${row.mainClassNumber}`,
      sortable: false,
    },
  ];

  const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: "ALL",
  };

  const useStyles = makeStyles(theme => ({
    root: {
      width: '50%',
      '& > * + *': {
        marginTop: theme.spacing(2),
      },
    },
  }));

  const customStyles = {
    rows: {
      style: {
        minHeight: '72px',
        backgroundColor: '#cccccc',
      },
    },
    headCells: {
      style: {
        paddingLeft: '8px',
        paddingRight: '8px',
      },
    },
    cells: {
      style: {
        fontSize: '17px',
        fontWeight: 600,
        color: '#555555 !important',
      },
    },
  };

  const expandComp = (row, i) => {
    if (closeRow?.mainClassNumber == row?.mainClassNumber) {
      return false
    } else {
      return true
    }

  }
  const showSelectRow = (row) => {
    if (closeRow?.mainClassNumber == row?.mainClassNumber) {
      return true
    } else {
      return false
    }

  }
  const isRowSelectable = (row) => {
    return row.isApproved == false ? true : false;
  };

  const onSubmit = async () => {
    setIsLoading(true)
    var temp = []
    approvedArr.map((a) => {
      var obj = {}
      const hasSelected = a.newMatchedTimings.some(t => t.isSelected);

      const timingsToUse = a.newMatchedTimings.filter(t => t.isSelected)

      // const timingsToUse = hasSelected
      //   ? a.newMatchedTimings.filter(t => t.isSelected)
      //   : a.newMatchedTimings;

      timingsToUse.map((q) => {
        var timee = (q.classTime).split('-')
        var toTime = timee[1].slice(0, -3)
        obj[q?.classDay] = {
          "from": timee[0],
          "to": toTime
        }

      })

      temp.push({
        "mainClassNumber": a.mainClassNumber,
        "matchedTimings": a.matchedTimings,
        "selectedSchedule": obj,
        "matchedIn": a.matchedIn,
        "language": a.language,
        "availableStartDate": a.availableStartDate,
        "students": a.students,
        "generatedHash": a.generatedHash,
        "instructorAccepted": a.instructorAccepted,
        "instructorEmail": a.instructorEmail,
        "instructorId": a.instructorId,
        "instructorName": a.instructorName,
        "isApproved": a.isApproved,
        "isFlex": a.isFlex,
        "isReady": a.isReady,
        "isReadyToApprove": a.isReadyToApprove,
        "isTimesSetup": a.isTimesSetup
      })
    })
    var token = localStorage.getItem('access_token');
    let path = config.siteUrl;
    await axios.post(path + '/classes/group-raw-data', {
      data: temp
    }, {
      headers: { 'content-Type': 'application/json', Authorization: `${token}` },
    })
      .then((response) => {
        proceedFunc()
        setTimeout(() =>
          setIsSuccessShow(true)
          , 2000)
        setIsLoading(false)
      })
      .catch((error) => {
        console.log(error)
        setIsLoading(false)
      });
  }
  const onProceed = () => {
    setIsShow(false)
    onSubmit()
  }
  const onClose = () => {
    setIsSuccessShow(false)
    let aprArr = []
    approvedArr.map((apr) => {
      aprArr.push(apr.mainClassNumber)
    })
    const filteredArray = regualarClasses.filter(item => !aprArr.includes(item.mainClassNumber));
    setRegualarClasses(filteredArray)
  }

  const sendSou = async (newArray) => {
    var temp = []
    newArray.map((data) => {

      temp.push({
        "mainClassNumber": data.mainClassNumber,
        "selectedSchedule": data.selectedSchedule,
        "language": data.language,
        "availableStartDate": data.availableStartDate,
        "availableEndDate": data.students[0]?.availableEndDate ?? null,
        "students": data.students,
        "generatedHash": data.generatedHash,
        "instructorAccepted": data.instructorAccepted,
        "instructorEmail": data.instructorEmail,
        "instructorId": data.instructorId,
        "instructorName": data.instructorName,
        "isApproved": data.isApproved,
        "isFlex": data.isFlex,
        "isReady": data.isReady,
        "isReadyToApprove": data.isReadyToApprove,
        "isTimesSetup": data.isTimesSetup
      })
    })
    const token = localStorage.getItem('access_token');
    let path = config.siteUrl;
    await axios.post(path + '/classes/send-sou', {
      data: temp
    }, {
      headers: { 'content-Type': 'application/json', Authorization: `${token}` },
    })
      .then((response) => {
      })
      .catch((error) => {
        console.log(error)
      });
  }

  const onAddToClass = async () => {
    var studentObj = fullData?.students.filter((item) => item?.id == studentId)
    var temp = []
    var obj = {}
    fullData?.newMatchedTimings.map((q) => {
      var timee = (q.classTime).split('-')
      var toTime = timee[1].slice(0, -3)
      obj[q?.classDay] = {
        "from": timee[0],
        "to": toTime
      }

    })

    const newTime = (matchedIn = "") => {
      const result = {}

      matchedIn
        .split("&&&")
        .filter(Boolean)
        .forEach((item) => {
          const [day, fromTime, toTime] = item.split(" - ")

          result[day] = {
            from: fromTime.replace(":", ""),
            to: toTime.replace(":", ""),
          }
        })

      return result
    }
    temp.push({
      "mainClassNumber": canAddedData.mainClassNumber,
      "matchedTimings": newTime(canAddedData.matchedIn),
      "selectedSchedule": newTime(canAddedData.matchedIn),
      "matchedIn": fullData?.matchedIn,
      "language": fullData?.language,
      "availableStartDate": canAddedData.availableStartDate,
      "students": studentObj,
      "generatedHash": fullData.generatedHash,
      "instructorAccepted": true,
      "instructorEmail": '',
      "instructorId": canAddedData.instructorId,
      "instructorName": canAddedData.instructorName,
      "isApproved": true,
      "isFlex": fullData?.isFlex,
      "isReady": true,
      "isReadyToApprove": fullData?.isReadyToApprove,
      "isTimesSetup": fullData?.isTimesSetup
    })
    var token = localStorage.getItem('access_token');
    let path = config.siteUrl;
    await axios.post(path + '/classes/group-raw-data', {
      data: temp
    }, {
      headers: { 'content-Type': 'application/json', Authorization: `${token}` },
    })
      .then((response) => {
        sendSou(temp)
        setIsSuccessShow(true)
        const studentIdSet = new Set(
          studentObj.map((s) => s.id)
        );

        const filteredArray = regualarClasses.filter(
          (item) => {
            return !item.students?.some((stu) =>
              studentIdSet.has(stu.id)
            );
          }
        );

        setRegualarClasses(filteredArray);
      })
      .catch((error) => {
        console.log(error)
      });

  }

  const proceedFunc = () => {
    var studentId = []
    approvedArr.map((a) => {
      a.students.map((item) => {
        if (!studentId.includes(item.id)) {
          studentId.push(item.id)
        }
      })
    })
    props.setApprovedRegArr(props?.selectRegularArr.filter((item) => !studentId.includes(item?.id)))
  }
  return (
    <>
      <LoadingSpinner isLoading={isLoading} />
      <div>
        <div className="row mb-4 ">
          <div className="col-md-12">
            {regualarClasses.length > 0 ?
              <div className="card m-overflow-h todo-card-list" style={{ border: 'none' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#8A8A8A', cursor: 'pointer' }} onClick={toggleCollapse}>
                  <div className='heading-texts-2' style={{ color: '#ffffff', marginLeft: '20px' }}>
                    Grouped Classes
                  </div>
                  <div>
                    <img
                      src={isOpen == true ? UpImg : downImg}
                      style={{ width: '26px', height: '26px', cursor: 'pointer', marginRight: '20px' }}
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-between">
                  <div className="col-lg-3 mt-2">
                    <CustomSearch filterText={filterText} onFilter={handleFilterChange} />
                  </div>

                  {/* <div className="col-lg-3  mt-2">
                    <div>
                      <Select
                        name="languages"
                        value={langVal}
                        options={langOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        isClearable={isClearable}
                        onChange={(e) => setLangVal(e)}
                      />
                    </div>
                  </div> */}
                </div>

                <div className="card-body m-p-0 p-0">
                  <Collapse in={isOpen}>
                    <div>
                      <DataTableExtensions
                        columns={columns}
                        data={
                          regualarClasses.filter((item) => {
                            const filter = filterText.toLowerCase().trim();

                            const itemMatch = Object.values(item).some((value) =>
                              String(value).toLowerCase().includes(filter)
                            );

                            const studentMatch = item.students?.some((student) =>
                              Object.entries(student).some(([key, value]) => {
                                const strValue = String(value).toLowerCase();

                                if (key === "courseNumber") {
                                  const match = String(value).match(/-(\d{2}).*(\w{2})$/);
                                  const extracted = match ? match[1] + match[2] : "";
                                  if (extracted.toLowerCase() === filter) {
                                    return true;
                                  }
                                }

                                return strValue.includes(filter);
                              })
                            );

                            const langMatch = !langVal || item.language.code === langVal.value;

                            return (itemMatch || studentMatch) && langMatch;
                          })
                        }
                        print={false}
                        export={false}
                        filter={false}
                      >
                        <DataTable
                          expandableRows
                          expandableRowExpanded={(row) => expandComp(row)}
                          expandableRowsComponent={ExpandedComponent}
                          pagination
                          expandOnRowClicked
                          selectableRows
                          selectableRowSelected={(row) => approvedArr.some(item => item?.mainClassNumber == row.mainClassNumber)}
                          expandableRowsComponentProps={{
                            "setShowModal": setShowModal,
                            "setLangId": setLangId,
                            "setSelectedRow": setSelectedRow,
                            "setCloseRow": setCloseRow,
                            "setShowTime": setShowTime,
                            "filterText": filterText,
                            "setApprovedArr": setApprovedArr,
                            "approvedArr": approvedArr,
                            "setShowCanAddedModal": setShowCanAddedModal,
                            "setShowCanAddedPotential": setShowCanAddedPotential,
                            "setCanAddedData": setCanAddedData,
                            "setFullData": setFullData,
                            "setStudentId": setStudentId,
                            "regularArr": props?.selectRegularArr,
                            "setApprovedRegArr": props?.setApprovedRegArr

                          }}
                          onSelectedRowsChange={({ selectedRows }) => {
                            setApprovedArr(selectedRows);
                          }}
                          paginationPerPage={10}
                          paginationRowsPerPageOptions={[10, 25, 50, 100]}
                          selectableRowDisabled={isRowSelectable}
                          noTableHead={true}
                          expandableRowsHideExpander={true}
                          customStyles={customStyles}
                          className="custom-table-border"
                        />

                      </DataTableExtensions>
                      <Row className="w-100 display-center mt-5">
                        <div className="btn-box-2">
                          <div className="main-btn" onClick={() => {
                            if (approvedArr.length > 0) {
                              setIsShow(true)


                            } else {
                              toast.error('Please select classes')
                            }
                          }} >
                            Approve grouped classes
                          </div>
                        </div>
                      </Row>
                    </div>
                  </Collapse>
                </div>
              </div>
              :
              <div className="no-record">
                There are no records to display.
              </div>
            }
          </div>
        </div>
      </div>
      {showModal == true ?
        <SetupModal
          showModal={showModal}
          setShowModal={setShowModal}
          lang_id={lang_id}
          setIsSetup={setIsSetup}
          setCloseRow={setCloseRow}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          closeRow={closeRow}
          showTime={showTime}
          isIstructorValue={true}
        // regualarClasses={regualarClasses}
        />
        : null}

      {isSuccessShow == true ?
        <SuccessModal
          isSuccessShow={isSuccessShow}
          setIsSuccessShow={setIsSuccessShow}
          onClose={onClose}
        />
        : null}
      {isShow == true ?
        <WarningModal
          isShow={isShow}
          setIsShow={setIsShow}
          onProceed={onProceed}

        />
        : null}

      {showCanAddedModal == true ?
        <CanBeAddedModal
          showModal={showCanAddedModal}
          setShowModal={setShowCanAddedModal}
          canAddedData={canAddedData}
          fullData={fullData}
          onProceed={onAddToClass}
        // lang_id={lang_id}
        // setIsSetup={setIsSetup}
        // setCloseRow={setCloseRow}
        // selectedRow={selectedRow}
        // setSelectedRow={setSelectedRow}
        // closeRow={closeRow}
        // showTime={showTime}
        // regualarClasses={regualarClasses}
        />
        : null}
      {showCanAddedPotential == true ?
        <CanBeAddedModal
          showModal={showCanAddedPotential}
          setShowModal={setShowCanAddedPotential}
          canAddedData={canAddedData}
          fullData={fullData}
          onProceed={onAddToClass}
        />
        : null}
    </>
  )
}
export default GroupedClasses